/** Maltaca ve Latin harflerini ASCII'ye indirip URL parçası üretir: "San Ġiljan" → "san-giljan". */
export function slugify(s: string): string {
  return s
    .toLowerCase()
    .replace(/għ/g, "gh")
    .replace(/ħ/g, "h")
    .replace(/ġ/g, "g")
    .replace(/ċ/g, "c")
    .replace(/ż/g, "z")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}
